import { Socket, Manager } from "socket.io-client";
import { LikeParams } from "../../domain/entities/emitLikeParams";

export interface MatchSocketDataSource {
	connectSocket(): Promise<void>;
	disconnectSocket(): Promise<void>;
	emitLike(userId: string, type: string): Promise<void>;
	onNotificationLike(callback: (data: LikeParams) => void): void;
}

export class MatchSocketDataSourceImpl implements MatchSocketDataSource {
	private socket: Socket | null = null;
	private onNotificationCallback: ((data: LikeParams) => void) | null = null; 

	async connectSocket(): Promise<void> {
		const token = localStorage.getItem("userToken");
		if (!token) {
			throw new Error("No se encontró el token");
		}

		const manager = new Manager(
			`${process.env.REACT_APP_UNJABBED}/socket.io/socket.io.js`,
			{
				transports: ["websocket"],
				extraHeaders: {
					authorization: `Bearer ${token}`,
				},
			}
		);

		this.socket = manager.socket("/match", { auth: { token } });
		this.socket.connect();

		this.socket.on("notification_like", (data: LikeParams) => {
			if (this.onNotificationCallback) {
				this.onNotificationCallback(data);
			}
		});

		this.socket.on("error", (data) => {
			console.error("Error en el socket:", data);
		});
	}

	disconnectSocket(): Promise<void> {
		return new Promise((resolve) => {
			if (this.socket) {
				this.socket.disconnect();
				this.socket = null;
			}
			resolve();
		});
	}

	async emitLike(userId: string, type: string): Promise<void> {
		if (!this.socket) {
			throw new Error();
		}

		this.socket.emit("like", { user_id: userId, type });
	}

	onNotificationLike(callback: (data: LikeParams) => void): void { 
		this.onNotificationCallback = callback;
	}
}
